
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Ticket } from "lucide-react";

interface LotterySelectorProps {
  selectedLottery: string;
  onLotteryChange: (value: string) => void;
  disabled?: boolean;
}

const LotterySelector: React.FC<LotterySelectorProps> = ({ selectedLottery, onLotteryChange, disabled = false }) => {
  return (
    <Card className={disabled ? "opacity-50" : ""}>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Ticket className="w-5 h-5" />
          Loteria
        </CardTitle>
        <CardDescription>
          Selecione a loteria para gerar palpites
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Select value={selectedLottery} onValueChange={onLotteryChange} disabled={disabled}>
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="z-50 bg-background border border-border shadow-lg">
            <SelectItem value="abaese-itabaiana" className="text-foreground hover:bg-muted focus:bg-muted">ABAESE - Itabaiana Paratodos (SE)</SelectItem>
            <SelectItem value="paratodos" className="text-foreground hover:bg-muted focus:bg-muted">Paratodos</SelectItem>
            <SelectItem value="look-goias" className="text-foreground hover:bg-muted focus:bg-muted">Look Goiás</SelectItem>
            <SelectItem value="jogo-bicho" className="text-foreground hover:bg-muted focus:bg-muted">Jogo do Bicho</SelectItem>
            <SelectItem value="federal" className="text-foreground hover:bg-muted focus:bg-muted">Federal</SelectItem>
            <SelectItem value="federal-extra" className="text-foreground hover:bg-muted focus:bg-muted">Federal Extra</SelectItem>
            <SelectItem value="maluquinha" className="text-foreground hover:bg-muted focus:bg-muted">Maluquinha</SelectItem>
            <SelectItem value="minas-gerais" className="text-foreground hover:bg-muted focus:bg-muted">Minas Gerais</SelectItem>
            <SelectItem value="bahia" className="text-foreground hover:bg-muted focus:bg-muted">Bahia</SelectItem>
            <SelectItem value="bahia-maluca" className="text-foreground hover:bg-muted focus:bg-muted">Bahia Maluca</SelectItem>
            <SelectItem value="capital" className="text-foreground hover:bg-muted focus:bg-muted">Capital</SelectItem>
            <SelectItem value="monte-carlos" className="text-foreground hover:bg-muted focus:bg-muted">Monte Carlos</SelectItem>
            <SelectItem value="lotece-lotep" className="text-foreground hover:bg-muted focus:bg-muted">LOTECE/LOTEP</SelectItem>
            <SelectItem value="nacional" className="text-foreground hover:bg-muted focus:bg-muted">Nacional</SelectItem>
            <SelectItem value="sao-paulo-pt" className="text-foreground hover:bg-muted focus:bg-muted">São Paulo PT</SelectItem>
          </SelectContent>
        </Select>
      </CardContent>
    </Card>
  );
};

export default LotterySelector;
